module.exports = __webpack_public_path__ + "img/img02.a31210ef.png";